import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import { Delete } from "@mui/icons-material";
import { BodyMessage, ButtonContainer, HeaderModal, ModalBox } from "./styles";
import { deleteReservations } from "../../services/reservations/deleteReservations";
import { DeleteReservationsModalProps } from "./types";
import { useToasts } from "react-toast-notifications";

const DeleteReservationModal: React.FC<DeleteReservationsModalProps> = ({
  reservationId,
}) => {
  const jwt = localStorage.getItem("jwt");
  const { addToast } = useToasts();

  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);

  const handleOpen = () => {
    setOpen(true);
  };

  // ------------------- GET RESOURCES FROM API -------------------
  const cancelReservation = async () => {
    await deleteReservations(jwt!, reservationId)
      .then((res) => {
        addToast("Reservación cancelada correctamente", {
          appearance: "success",
          autoDismiss: true,
        });
        handleClose();
        setTimeout(() => {
          window.location.reload();
        }, 1500); // 2000 milisegundos = 2 segundos
      })
      .catch((err) => {
        addToast("Error al cancelar reservación", {
          appearance: "error",
          autoDismiss: true,
        });
      });
      setOpen(false);
  }

  return (
    <div>
      <Button
        variant="contained"
        startIcon={<Delete />}
        sx={{
          width: "100%",
          borderRadius: "12px",
          fontSize: "18px",
          backgroundColor: "#BD2424",
          color: "#FFFFFF",
          textTransform: "none",
          "&:hover": {
            backgroundColor: "#921D1D",
          },
        }}
        onClick={handleOpen}
      >
        Cancelar reservación
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <ModalBox>
            <HeaderModal>Cancelar reservación</HeaderModal>
            <BodyMessage>
              ¿Estás seguro que deseas cancelar esta reservación?
            </BodyMessage>
            <ButtonContainer>
              <Button
                variant="contained"
                startIcon={<Delete />}
                sx={{
                  width: "100%",
                  borderRadius: "12px",
                  fontSize: "18px",
                  backgroundColor: "#BD2424",
                  color: "#FFFFFF",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#921D1D",
                  },
                }}
                onClick={cancelReservation}
              >
                Cancelar reservación
              </Button>
            </ButtonContainer>
          </ModalBox>
        </Fade>
      </Modal>
    </div>
  );
};

export default DeleteReservationModal;
